import React from 'react';
import { Link } from 'react-router-dom';

const About: React.FC = () => {
  const team = [
    { name: 'AI Specialist', role: 'Lead AI Engineer', description: 'Expert in machine learning and NLP', icon: 'M9.75 17L9 20l-1 1h8l-1-1-.75-3M3 13h18M5 17h14a2 2 0 002-2V5a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z' },
    { name: 'Automation Expert', role: 'Business Automation Lead', description: 'Specializes in process optimization', icon: 'M4 5a1 1 0 011-1h14a1 1 0 011 1v2a1 1 0 01-1 1H5a1 1 0 01-1-1V5zM4 13a1 1 0 011-1h6a1 1 0 011 1v6a1 1 0 01-1 1H5a1 1 0 01-1-1v-6zM16 13a1 1 0 011-1h2a1 1 0 011 1v6a1 1 0 01-1 1h-2a1 1 0 01-1-1v-6z' },
    { name: 'Solution Architect', role: 'Technical Architect', description: 'Designs scalable AI solutions', icon: 'M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4' },
    { name: 'Customer Success', role: 'Client Success Manager', description: 'Ensures client satisfaction and adoption', icon: 'M14.828 14.828a4 4 0 01-5.656 0M9 10h.01M15 10h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z' }
  ];

  return (
    <div>
      {/* Hero Section */}
      <section className="bg-primary pt-32 pb-20 lg:pt-40">
        <div className="max-w-[1536px] mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center">
            <h1 className="text-4xl md:text-5xl font-bold text-white mb-6 font-inter">
              About icubechat
            </h1>
            <p className="text-xl text-gray-100 mb-8 max-w-3xl mx-auto">
              Delivering innovative IT solutions that transform businesses and drive digital growth
            </p>
          </div>
        </div>
      </section>

      {/* Vision & Mission */}
      <section className="py-20 bg-white">
        <div className="max-w-[1536px] mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
            <div className="group relative bg-white rounded-2xl p-8 shadow-lg hover:shadow-2xl transition-all duration-300 border border-gray-200 hover:border-primary/20 transform hover:-translate-y-2 overflow-hidden h-full">
              <div className="absolute inset-0 bg-gradient-to-br from-primary/5 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
              <div className="relative z-10 text-center lg:text-left">
                <div className="w-16 h-16 bg-primary rounded-2xl flex items-center justify-center mx-auto lg:mx-0 mb-6 transition-transform duration-300 group-hover:scale-105 shadow-lg shadow-primary/20">
                  <svg className="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
                  </svg>
                </div>
                <h2 className="text-3xl font-bold text-primary mb-4 group-hover:text-primary transition-colors duration-300">Our Vision</h2>
                <p className="text-lg text-gray-600 mb-6">
                  To become a globally recognized IT services leader, empowering businesses of all sizes to leverage innovative digital solutions for sustainable growth and operational excellence.
                </p>
                <p className="text-lg text-gray-600">
                  We envision a future where every business, regardless of size or industry, can seamlessly integrate cutting-edge technology to optimize processes, enhance digital experiences, and drive technological innovation.
                </p>
              </div>
            </div>

            <div className="group relative bg-white rounded-2xl p-8 shadow-lg hover:shadow-2xl transition-all duration-300 border border-gray-200 hover:border-primary/20 transform hover:-translate-y-2 overflow-hidden h-full">
              <div className="absolute inset-0 bg-gradient-to-br from-secondary/5 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
              <div className="relative z-10 text-center lg:text-left">
                <div className="w-16 h-16 bg-secondary rounded-2xl flex items-center justify-center mx-auto lg:mx-0 mb-6 transition-transform duration-300 group-hover:scale-105 shadow-lg shadow-secondary/20">
                  <svg className="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" />
                  </svg>
                </div>
                <h2 className="text-3xl font-bold text-primary mb-4 group-hover:text-secondary transition-colors duration-300">Our Mission</h2>
                <p className="text-lg text-gray-600 mb-6">
                  To deliver scalable, secure, and user-centric IT solutions that solve complex business challenges and create measurable value for our clients across the globe.
                </p>
                <p className="text-lg text-gray-600">
                  We are committed to providing top-tier technological expertise, making advanced digital services accessible and affordable for businesses to transform their operations, improve efficiency, and achieve their strategic goals.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Why icubechat */}
      <section className="py-20 bg-light">
        <div className="max-w-[1536px] mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-4xl font-bold text-primary mb-4">
              Why Choose icubechat
            </h2>
            <p className="text-xl text-gray-600 max-w-2xl mx-auto">
              We combine cutting-edge technology with business expertise to deliver exceptional results
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            <div className="group relative bg-white rounded-2xl p-6 shadow-sm hover:shadow-2xl transition-all duration-300 border border-gray-200 hover:border-primary/20 transform hover:-translate-y-2 overflow-hidden flex flex-col justify-center items-center text-center h-full">
              <div className="absolute inset-0 bg-gradient-to-br from-primary/5 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
              <div className="relative z-10 p-4">
                <div className="w-16 h-16 bg-primary rounded-2xl flex items-center justify-center mx-auto mb-4 transition-transform duration-300 group-hover:scale-110 shadow-lg shadow-primary/20">
                  <svg className="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z" />
                  </svg>
                </div>
                <h3 className="text-xl font-semibold text-primary mb-3 group-hover:text-primary transition-colors duration-300">AI-First Approach</h3>
                <p className="text-gray-600">
                  We build solutions with AI at the core, ensuring intelligent automation that learns and adapts to your business needs.
                </p>
              </div>
            </div>

            <div className="group relative bg-white rounded-2xl p-6 shadow-sm hover:shadow-2xl transition-all duration-300 border border-gray-200 hover:border-primary/20 transform hover:-translate-y-2 overflow-hidden flex flex-col justify-center items-center text-center h-full">
              <div className="absolute inset-0 bg-gradient-to-br from-secondary/5 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
              <div className="relative z-10 p-4">
                <div className="w-16 h-16 bg-secondary rounded-2xl flex items-center justify-center mx-auto mb-4 transition-transform duration-300 group-hover:scale-105 shadow-lg shadow-secondary/20">
                  <svg className="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
                  </svg>
                </div>
                <h3 className="text-xl font-semibold text-primary mb-3 group-hover:text-secondary transition-colors duration-300">Expert Team</h3>
                <p className="text-gray-600">
                  Our team of AI specialists, automation experts, and business consultants brings diverse expertise to every project.
                </p>
              </div>
            </div>

            <div className="group relative bg-white rounded-2xl p-6 shadow-sm hover:shadow-2xl transition-all duration-300 border border-gray-200 hover:border-primary/20 transform hover:-translate-y-2 overflow-hidden flex flex-col justify-center items-center text-center h-full">
              <div className="absolute inset-0 bg-gradient-to-br from-dark/5 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
              <div className="relative z-10 p-4">
                <div className="w-16 h-16 bg-dark rounded-2xl flex items-center justify-center mx-auto mb-4 transition-transform duration-300 group-hover:scale-105 shadow-lg shadow-dark/20">
                  <svg className="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z" />
                  </svg>
                </div>
                <h3 className="text-xl font-semibold text-primary mb-3 group-hover:text-dark transition-colors duration-300">Client-Centric</h3>
                <p className="text-gray-600">
                  We prioritize your success, offering personalized solutions and ongoing support to ensure maximum ROI.
                </p>
              </div>
            </div>

            <div className="group relative bg-white rounded-2xl p-6 shadow-sm hover:shadow-2xl transition-all duration-300 border border-gray-200 hover:border-primary/20 transform hover:-translate-y-2 overflow-hidden flex flex-col justify-center items-center text-center h-full">
              <div className="absolute inset-0 bg-gradient-to-br from-primary/5 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
              <div className="relative z-10 p-4">
                <div className="w-16 h-16 bg-primary rounded-2xl flex items-center justify-center mx-auto mb-4 transition-transform duration-300 group-hover:scale-105 shadow-lg shadow-primary/20">
                  <svg className="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" />
                  </svg>
                </div>
                <h3 className="text-xl font-semibold text-primary mb-3 group-hover:text-primary transition-colors duration-300">Fast Implementation</h3>
                <p className="text-gray-600">
                  Our streamlined processes ensure quick deployment without compromising on quality or functionality.
                </p>
              </div>
            </div>

            <div className="group relative bg-white rounded-2xl p-6 shadow-sm hover:shadow-2xl transition-all duration-300 border border-gray-200 hover:border-primary/20 transform hover:-translate-y-2 overflow-hidden flex flex-col justify-center items-center text-center h-full">
              <div className="absolute inset-0 bg-gradient-to-br from-secondary/5 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
              <div className="relative z-10 p-4">
                <div className="w-16 h-16 bg-secondary rounded-2xl flex items-center justify-center mx-auto mb-4 transition-transform duration-300 group-hover:scale-105 shadow-lg shadow-secondary/20">
                  <svg className="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
                  </svg>
                </div>
                <h3 className="text-xl font-semibold text-primary mb-3 group-hover:text-secondary transition-colors duration-300">Secure & Compliant</h3>
                <p className="text-gray-600">
                  Enterprise-grade security and compliance with industry standards ensure your data is always protected.
                </p>
              </div>
            </div>

            <div className="group relative bg-white rounded-2xl p-6 shadow-sm hover:shadow-2xl transition-all duration-300 border border-gray-200 hover:border-primary/20 transform hover:-translate-y-2 overflow-hidden flex flex-col justify-center items-center text-center h-full">
              <div className="absolute inset-0 bg-gradient-to-br from-dark/5 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
              <div className="relative z-10 p-4">
                <div className="w-16 h-16 bg-dark rounded-2xl flex items-center justify-center mx-auto mb-4 transition-transform duration-300 group-hover:scale-105 shadow-lg shadow-dark/20">
                  <svg className="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 6V4m0 2a2 2 0 100 4m0-4a2 2 0 110 4m-6 8a2 2 0 100-4m0 4a2 2 0 110-4m0 4v2m0-6V4m6 6v10m6-2a2 2 0 100-4m0 4a2 2 0 110-4m0 4v2m0-6V4" />
                  </svg>
                </div>
                <h3 className="text-xl font-semibold text-primary mb-3 group-hover:text-dark transition-colors duration-300">Scalable Solutions</h3>
                <p className="text-gray-600">
                  Our solutions grow with your business, offering flexibility and scalability to meet evolving needs.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Our Values */}
      <section className="py-20 bg-white">
        <div className="max-w-[1536px] mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-4xl font-bold text-primary mb-4">
              Our Core Values
            </h2>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            <div className="group relative text-center p-6 bg-white rounded-2xl shadow-sm hover:shadow-2xl transition-all duration-300 border border-gray-200 hover:border-primary/20 transform hover:-translate-y-2 overflow-hidden flex flex-col justify-center items-center h-full">
              <div className="absolute inset-0 bg-gradient-to-br from-primary/5 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
              <div className="relative z-10 p-4">
                <div className="w-20 h-20 bg-primary/10 rounded-2xl flex items-center justify-center mx-auto mb-4 transition-transform duration-300 group-hover:scale-110 shadow-lg shadow-primary/10">
                  <svg className="w-8 h-8 text-primary" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" />
                  </svg>
                </div>
                <h3 className="text-xl font-semibold text-primary mb-2 group-hover:text-primary transition-colors duration-300">Innovation</h3>
                <p className="text-gray-600">Pushing boundaries with cutting-edge AI technology</p>
              </div>
            </div>

            <div className="group relative text-center p-6 bg-white rounded-2xl shadow-sm hover:shadow-2xl transition-all duration-300 border border-gray-200 hover:border-primary/20 transform hover:-translate-y-2 overflow-hidden flex flex-col justify-center items-center h-full">
              <div className="absolute inset-0 bg-gradient-to-br from-secondary/5 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
              <div className="relative z-10 p-4">
                <div className="w-20 h-20 bg-secondary/10 rounded-2xl flex items-center justify-center mx-auto mb-4 transition-transform duration-300 group-hover:scale-110 shadow-lg shadow-secondary/10">
                  <svg className="w-8 h-8 text-secondary" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
                  </svg>
                </div>
                <h3 className="text-xl font-semibold text-primary mb-2 group-hover:text-secondary transition-colors duration-300">Integrity</h3>
                <p className="text-gray-600">Building trust through transparency and honesty</p>
              </div>
            </div>

            <div className="group relative text-center p-6 bg-white rounded-2xl shadow-sm hover:shadow-2xl transition-all duration-300 border border-gray-200 hover:border-primary/20 transform hover:-translate-y-2 overflow-hidden flex flex-col justify-center items-center h-full">
              <div className="absolute inset-0 bg-gradient-to-br from-dark/5 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
              <div className="relative z-10 p-4">
                <div className="w-20 h-20 bg-dark/10 rounded-2xl flex items-center justify-center mx-auto mb-4 transition-transform duration-300 group-hover:scale-110 shadow-lg shadow-dark/10">
                  <svg className="w-8 h-8 text-dark" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
                  </svg>
                </div>
                <h3 className="text-xl font-semibold text-primary mb-2 group-hover:text-dark transition-colors duration-300">Customer Focus</h3>
                <p className="text-gray-600">Putting our clients' success at the center of everything</p>
              </div>
            </div>

            <div className="group relative text-center p-6 bg-white rounded-2xl shadow-sm hover:shadow-2xl transition-all duration-300 border border-gray-200 hover:border-primary/20 transform hover:-translate-y-2 overflow-hidden flex flex-col justify-center items-center h-full">
              <div className="absolute inset-0 bg-gradient-to-br from-primary/5 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
              <div className="relative z-10 p-4">
                <div className="w-20 h-20 bg-primary/10 rounded-2xl flex items-center justify-center mx-auto mb-4 transition-transform duration-300 group-hover:scale-110 shadow-lg shadow-primary/10">
                  <svg className="w-8 h-8 text-primary" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 3v4M3 5h4M6 17v4m-2-2h4m5-16l2.286 6.857L21 12l-5.714 2.143L13 21l-2.286-6.857L5 12l5.714-2.143L13 3z" />
                  </svg>
                </div>
                <h3 className="text-xl font-semibold text-primary mb-2 group-hover:text-primary transition-colors duration-300">Excellence</h3>
                <p className="text-gray-600">Delivering exceptional quality in every solution</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Team Section */}
      <section className="py-20 bg-light">
        <div className="max-w-[1536px] mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-4xl font-bold text-primary mb-4">
              Our Expert Team
            </h2>
            <p className="text-xl text-gray-600 max-w-2xl mx-auto">
              Meet the talented professionals behind icubechat's success
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            {team.map((member, index) => (
              <div key={index} className="group relative text-center p-6 bg-white rounded-2xl shadow-sm hover:shadow-2xl transition-all duration-300 border border-gray-200 hover:border-primary/20 transform hover:-translate-y-2 overflow-hidden flex flex-col justify-center items-center h-full">
                <div className="absolute inset-0 bg-gradient-to-br from-primary/5 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
                <div className="relative z-10 p-4 w-full">
                  <div className="w-24 h-24 bg-primary rounded-full flex items-center justify-center mx-auto mb-4 transition-transform duration-300 group-hover:scale-105 shadow-xl shadow-primary/20 ring-4 ring-primary/10">
                    <svg className="w-12 h-12 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d={member.icon} />
                    </svg>
                  </div>
                  <h3 className="text-lg font-semibold text-primary mb-1 group-hover:text-primary transition-colors duration-300">{member.name}</h3>
                  <p className="text-secondary font-medium mb-2">{member.role}</p>
                  <p className="text-gray-600 text-sm">{member.description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-14 bg-white border-t border-gray-100 mt-10">
        <div className="max-w-[1536px] mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-3xl md:text-4xl font-bold text-[#0B1538] mb-4">
            Ready to Transform Your Business?
          </h2>
          <p className="text-xl text-gray-600 mb-8 max-w-2xl mx-auto">
            Join hundreds of businesses already leveraging our AI solutions for growth and efficiency.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link
              to="/contact"
              className="px-8 py-4 bg-[#0B25E6] text-white rounded-lg hover:bg-blue-800  transition-colors text-lg font-semibold"
            >
              Start Your Journey
            </Link>
            <Link
              to="/services"
              className="px-8 py-4 text-[#0B25E6] border-2 border-[#0B25E6] rounded-lg hover:bg-[#0B25E6] hover:text-white transition-colors text-lg font-semibold bg-transparent"
            >
              Explore Our Services
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default About;
